var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SecondaryBtn",
    _vm._g(_vm._b({}, "SecondaryBtn", _vm.$attrs, false), _vm.$listeners),
    [_vm._v("\n  Close\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }